import Vuei18n from '@/translations';

async function getAmountAdvertisements() {
  const responsePromise = await fetch('/advertisementsAmount.json');

  const response = await responsePromise.json();
  const formattedData = response.map(item => ({
    x: item.label,
    y: item.amount,
  }));

  return [
    {
      name: Vuei18n.t('advertisements'),
      data: formattedData,
    },
  ];
}

export default getAmountAdvertisements;
